import { MenuItem } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SessionSchedulingDialog from './SessionSchedulingDialog';

SessionSchedulingMenuItem.propTypes = {
    onClose: PropTypes.func,
    onCreateClick: PropTypes.func,
    disabled: PropTypes.bool,
    sessions: PropTypes.array,
};
function SessionSchedulingMenuItem({ sessions, onCreateClick, onClose, disabled }) {
    const [schedulingDialogOpen, setSchedulingDialogOpen] = useState(false);
    const { t } = useTranslation();

    const handleOpenScheduleCallClick = () => setSchedulingDialogOpen(true);
    const onScheduleDialogClose = () => {
        setSchedulingDialogOpen(false);
        onClose();
    }

    return (
        <>
            <MenuItem
                onClick={handleOpenScheduleCallClick}
                disabled={disabled}
            >
                {t("sc_session")}
            </MenuItem>
            <SessionSchedulingDialog
                sessions={sessions}
                open={schedulingDialogOpen}
                onClose={onScheduleDialogClose}
                onSubmit={onCreateClick}
            />
        </>
    );
}

export default SessionSchedulingMenuItem;